import { Route, Routes } from "react-router-dom";
import { ModelsUI } from "./ModelsUI";
import "./index.css";

export function App() {
	return (
		<div className="app">
			<Routes>
				<Route path="/" element={<ModelsUI />} />
				<Route path="/:provider" element={<ModelsUI />} />
			</Routes>
		</div>
	);
}

export default App;
